import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  ChangePasswordPayload,
  ForgotPayload,
  LoginPayload,
  LoginResponse,
  ResetPasswordResponse,
  updateProfile,
  VerifyOtpPayload,
} from '../models/auth.model';
import { CommonResponse } from '../models/commonResponse.model';
import { apiList } from './apiList';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  emailSubject: BehaviorSubject<ForgotPayload | null> =
    new BehaviorSubject<ForgotPayload | null>(null);

  profileDetails: BehaviorSubject<LoginResponse | null> =
    new BehaviorSubject<LoginResponse | null>(null);

  resetTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();
  toggleSidebarView(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  constructor(
    private readonly http: HttpClient,
    private _apiList: apiList
  ) {}

  isAuthenticated(): boolean {
    if (
      localStorage.getItem(environment.storageKey) &&
      localStorage.getItem(environment.storageKey) !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  loginUser(loginDetails: LoginPayload): Observable<LoginResponse> {
    return this.http
      .post<{
        data: LoginResponse;
      }>(`${this._apiList.login}`, loginDetails)
      .pipe(map(res => res.data));
  }

  forgotPassword(email: ForgotPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${this._apiList.forgotPassword}`,
      email
    );
  }

  resetPassword(data: VerifyOtpPayload): Observable<ResetPasswordResponse> {
    return this.http
      .post<ResetPasswordResponse>(`${this._apiList.resetPassword}`, data)
      .pipe(map(res => res));
  }

  getProfile(): Observable<LoginResponse> {
    return this.http
      .get<{
        data: LoginResponse;
      }>(`${this._apiList.profile}`)
      .pipe(map(res => res.data));
  }

  updateProfile(data: updateProfile): Observable<LoginResponse> {
    return this.http
      .put<{
        data: LoginResponse;
      }>(`${this._apiList.profile}`, data)
      .pipe(map(res => res.data));
  }

  changePassword(data: ChangePasswordPayload): Observable<CommonResponse> {
    return this.http
      .post<CommonResponse>(`admin/user/change-password`, data)
      .pipe(map(res => res));
  }

  logout(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`admin/user/logout`);
  }
}
